'use client';
import { AddressForm } from '@baseball-near-you/ui';
import { env } from '@bb/env';
import { useTeamAddressCreationMutation } from '@bb/lib/mutations/useTeamAddressCreationMutation';
// import dynamic from 'next/dynamic';

// const AddressForm = dynamic(
//   () => import('@baseball-near-you/ui').then((mod) => mod.AddressForm),
//   {
//     ssr: false,
//   }
// );

export function AddTeamAddressForm(props: {
  teamId: number;
  onSuccess: () => void;
}) {
  const { createTeamAddress, isCreatingAddress } =
    useTeamAddressCreationMutation();

  return (
    <AddressForm
      isSubmitting={isCreatingAddress}
      onSubmit={async (data) => {
        await createTeamAddress({
          ...data,
          teamId: props.teamId,
        });
        props.onSuccess();
      }}
      buttonLabel="Add address"
      accessToken={env.NEXT_PUBLIC_MAPBOX_TOKEN}
    />
  );
}
